import { isEqual } from 'lodash-es';

export default {
  isDemoCompany: ({ user }) => {
    return isEqual(user?.selectedCompany?.type, 'demo');
  },
  securityPolicy: ({ securityPolicy }) => securityPolicy,
};
